<template>
  <div class="col-12">
    <SearchCard
      ref="allTicketSearch"
      :filterCatch="true"
      :title="$lang.check_tickets"
      :url="url"
      :html="false"
      :showQuickFilter="true"
      :parentParams="parentParams"
      :isImportExcel="true"
      :sampleDownload="$lang.ticketLang.all_ticket_sample_download"
      :isImportExcelTooltip="
        $lang.ticketLang.all_ticket_sample_download_tooltiop
      "
      @importExcel="showImportExcelModal"
      @updatePermissions="updatePermissions"
    >
      <template slot="buttons">
        <span
          v-if="isAdmin(permissions, ['admin'])"
          @click="openModal"
          v-b-tooltip.hover
          :title="$lang.ticketLang.group_end_request"
          class="ml-2"
        >
          <mdicon
            name="email-remove-outline"
            size="24"
            class="cursor_pointer"
          />
        </span>
        <span
          v-if="isAdmin(permissions, ['admin'])"
          @click="goToOperatorAddTicket"
          v-b-tooltip.hover
          :title="$lang.ticketLang.start_operator_ticket"
          class="ml-2"
        >
          <mdicon name="email-send-outline" size="24" class="cursor_pointer" />
        </span>
      </template>

      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="p-3 card_border_bottom color_second font_16 font_weight_bold bg-white"
          v-text="item.ticket_subject"
        />
        <b-col
          cols="12"
          md="12"
          class="p-3 d-flex align-items-start justify-content-between bg-white"
        >
          <AvatarInfo
            :downloadCode="pathOr(null, ['user', 'download_code'], item)"
            :title="pathOr(null, ['user', 'name'], item)"
            :description="pathOr(null, ['user', 'national_code'], item)"
            :genderId="pathOr(null, ['user', 'gender', 'id'], item)"
            :personCode="pathOr(null, ['user', 'person_code'], item)"
            :parvandehCode="pathOr(null, ['parvandeh', 'code'], item)"
          />
          <span
            v-text="pathOr('', ['ticket_status_id', 'caption'], item)"
            :class="`badge_style badge_style--${pathOr(
              'danger',
              ['ticket_status_id', 'color'],
              item
            )}`"
          />
        </b-col>
        <b-col cols="12" md="" class="color_second bg-white">
          <b-row>
            <b-col cols="12" md="12" class="color_black mb-2">
              <strong v-text="'نام دوره: '" />
              <span
                v-text="pathOr('', ['parvandeh', 'term', 'caption'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="color_black my-2">
              <strong v-text="`${$lang.ticketLang.parvandeh}: `" />

              <a
                class="color_primary"
                :href="goToParvandeh(item)"
                target="_blank"
                v-text="pathOr('', ['parvandeh', 'parvandeh_number'], item)"
              />
            </b-col>
            <b-col
              cols=""
              class="color_black d-md-none d-flex align-items-center my-2"
            >
              <strong v-text="'آخرین بررسی: '" />
              <span
                class="ml-1"
                v-text="
                  $moment(
                    pathOr('', ['updated_at', 'gregorian'], item)
                  ).fromNow()
                "
              />
            </b-col>
            <b-col cols="auto" md="" class="color_second mt-2">
              <mdicon name="phone-outline" size="24" class="rotate_icon" />
              <span
                v-text="pathOr('', ['user', 'mobile'], item)"
                class="color_black ml-2"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="3" class="pt-md-2 bg-white">
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="color_black text-md-center d-md-block d-none"
            >
              <strong v-text="'آخرین بررسی: '" />
              <span
                class="ml-1"
                v-text="
                  $moment(
                    pathOr('', ['updated_at', 'gregorian'], item)
                  ).fromNow()
                "
              />
            </b-col>
            <b-col cols="12" md="12" class="my-3">
              <span @click="editTicket(item)">
                <Button
                  :click="() => {}"
                  :title="buttonTitle(item)"
                  btnClass="font_20"
                />
              </span>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="pathOr([], ['tags'], item).length"
          cols="12"
          md="12"
          class="bg-white py-2 card_border_top"
        >
          <b-row class="mx-0">
            <b-col
              cols="auto"
              md="auto"
              class="pr-3"
              v-for="(tag, index) in pathOr([], ['tags'], item)"
              :key="index"
            >
              <div class="color_primary">
                <mdicon name="tag-outline" size="16" />
                <span
                  class="ml-1 font_12 font_weight_500"
                  v-text="tag.caption"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="importExcelModal"
      :title="$lang.ticketLang.upload_excel_file"
      size="lg"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          {{ $lang.ticketLang.all_ticket_upload_excel_form_title }}
        </div>
        <b-row>
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.ticketLang.subject}: `"
                :rules="$v.ticketSubject.$params"
              />
              <b-form-input
                v-model="$v.ticketSubject.$model"
                type="text"
                autocomplete="off"
                :state="
                  $v.ticketSubject.$dirty ? !$v.ticketSubject.$error : null
                "
                @input="submitImportExcel"
              />
              <b-form-invalid-feedback
                :state="
                  $v.ticketSubject.$dirty ? !$v.ticketSubject.$error : null
                "
              >
                <div v-if="!$v.ticketSubject.required">
                  {{ $lang.error_required | replace($lang.ticketLang.subject) }}
                </div>
                <div v-if="!$v.ticketSubject.maxLength">
                  {{ $lang.error_max | replace($lang.ticketLang.subject, 40) }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="`${$lang.ticketLang.ticket_unit}: `"
                :rules="$v.ticketUnitSelected.$params"
              />
              <selectFind
                :options="ticketUnitOptions"
                v-model="$v.ticketUnitSelected.$model"
                label="text"
                :isValid="
                  $v.ticketUnitSelected.$dirty
                    ? !$v.ticketUnitSelected.$error
                    : null
                "
                @input="submitImportExcel"
              />
              <b-form-invalid-feedback
                :state="
                  $v.ticketUnitSelected.$dirty
                    ? !$v.ticketUnitSelected.$error
                    : null
                "
              >
                <div v-if="!$v.ticketUnitSelected.required">
                  {{
                    $lang.error_required | replace($lang.ticketLang.ticket_unit)
                  }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="mb-3">
            <b-form-group label-cols="5">
              <requiredComponent
                slot="label"
                :label="`${$lang.ticketLang.ticket_send_sms}: `"
                :rules="$v.hasSendSms.$params"
              />
              <b-form-checkbox
                v-model="hasSendSms"
                name="check-button"
                switch
                class="mt-2"
              >
                <b v-if="hasSendSms" v-text="'بله'" class="text-success" />
                <b v-else v-text="'خیر'" class="text-danger" />
              </b-form-checkbox>
              <b-form-invalid-feedback
                :state="$v.hasSendSms.$dirty ? !$v.hasSendSms.$error : null"
              >
                <div v-if="!$v.hasSendSms.required">
                  {{
                    $lang.error_required
                      | replace($lang.ticketLang.ticket_send_sms)
                  }}
                </div>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <ShowCardUpload
          :url="uploadExcelUrl"
          :showAlert="exampleFileLink"
          :hasAppendData="true"
          :appendData="appendData"
          :isValidAppendData="isValidAppendData"
          @getItems="getItems"
          @submit="submitImportExcel"
          @closeModal="showImportExcelModal(false)"
        />
      </b-card>
    </b-modal>

    <b-modal v-model="isModal" size="md" hide-header hide-footer>
      <GroupEnd @close="closeModal" @getItems="getItems" />
    </b-modal>
  </div>
</template>

<script>
import SearchCard from "@/components/global/searchCard";
import Button from "@/components/global/Button";
import AvatarInfo from "@/components/global/AvatarInfo";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import GroupEnd from "./groupEnd";
import { required, maxLength } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { renderEumOptions, isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "new-all-ticket-search",
  components: {
    SearchCard,
    ShowCardUpload,
    GroupEnd,
    Button,
    AvatarInfo,
  },
  validations: {
    ticketSubject: { required, maxLength: maxLength(40) },
    ticketUnitSelected: { required },
    hasSendSms: { required },
  },
  data() {
    return {
      isModal: false,
      importExcelModal: false,
      ticketSubject: null,
      ticketUnitSelected: null,
      hasSendSms: false,
      isValidAppendData: false,
      permissions: [],
    };
  },
  computed: {
    parentParams() {
      const user_code = pathOr(null, ["user_code"], this.$route.query);
      return user_code ? { user_code } : {};
    },
    url() {
      return generateApiUrl(["ticket", "all_ticket"]);
    },
    uploadExcelUrl() {
      return generateApiUrl(["ticket", "import_ticket"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_ticket.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
    appendData() {
      return {
        ticket_subject: this.ticketSubject,
        ticket_unit_id: pathOr(null, ["value"], this.ticketUnitSelected),
        send_message: this.hasSendSms ? 1 : 0,
      };
    },
    ticketUnitOptions() {
      return renderEumOptions("ticket_unit");
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    openModal() {
      this.isModal = true;
    },
    closeModal() {
      this.isModal = false;
    },
    getItems() {
      this.$refs.allTicketSearch.getItems();
      this.isModal = false;
    },
    updatePermissions(data) {
      this.permissions = data;
    },
    editTicket(item) {
      const routeData = this.$router.resolve({
        name: "edit_all_ticket",
        params: {
          code: item.code,
        },
      });
      window.open(routeData.href, "_blank");
    },
    goToOperatorAddTicket() {
      const routeData = this.$router.resolve({
        name: "operator_add_ticket",
      });
      window.open(routeData.href, "_blank");
    },
    goToParvandeh(item) {
      const parvandeh_number = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const routerData = this.$router.resolve({
        name: "parvandeh_by_number",
        params: { parvandeh_number },
      });
      return routerData.href;
    },
    showImportExcelModal(state = true) {
      if (state) {
        this.$v.$reset();
        this.ticketSubject = null;
        this.ticketUnitSelected = null;
        this.hasSendSms = false;
        this.isValidAppendData = false;
      }
      this.importExcelModal = state;
    },
    submitImportExcel() {
      this.$v.$touch();
      this.isValidAppendData = !this.$v.$anyError;
    },
    buttonTitle(item) {
      const defaultText = isAdmin(this.permissions)
        ? this.$lang.ticketLang.result
        : this.$lang.view;
      return pathOr(null, ["ticket_status_id", "id"], item) === 4
        ? this.$lang.view
        : defaultText;
    },
  },
};
</script>
